module.exports = __webpack_public_path__ + "img/carteirinhaCaoFrente_1.7254df7a.jpeg";